var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-goto"},[_c('div',{staticClass:"pagination-goto__label"},[_vm._v("\n    "+_vm._s(_vm._getTr("go_to_page"))+"\n  ")]),_vm._v(" "),_c('MInput',{staticClass:"pagination-goto__input",attrs:{"small":true,"value":_vm.currentPageStr,"emit-input-only-on-change":false},on:{"input":_vm.changePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }